import script from "./AddCompanyForm.vue?vue&type=script&setup=true&lang=js"
export * from "./AddCompanyForm.vue?vue&type=script&setup=true&lang=js"

import "./AddCompanyForm.vue?vue&type=style&index=0&id=3c096188&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3c096188"]])

export default __exports__